import { z } from 'zod';

export const ownershipShema = z.object({
  type: z.enum(['INDIVIDUAL', 'PARTNERSHIP', 'CORPORATION'], {
    error: 'Select ownership type',
  }),
});

export type OwnershipFormValues = z.infer<typeof ownershipShema>;
